// Modal de ativacao do CEP unico. Aplica o CEP em massa nos bairros existentes.

import { AlertCircle, MapPin } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { formatCep } from "../lib/cep";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../../components/ui/dialog";

export default function CepUnicoDialog({
  open,
  onOpenChange,
  novoCep,
  setNovoCep,
  saving,
  onConfirmar,
  totalBairros,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <MapPin className="w-5 h-5 text-primary" />
            Ativar CEP Único
          </DialogTitle>
          <DialogDescription>
            Todos os bairros cadastrados e futuros usarão o mesmo CEP.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-3">
            <p className="text-sm text-blue-700 dark:text-blue-300">
              <strong>💡 Dica:</strong> Use esta opção se sua cidade/região usa um único CEP para
              todos os bairros.
            </p>
          </div>

          <div>
            <Label>CEP para todos os bairros *</Label>
            <Input
              value={novoCep}
              onChange={(e) => setNovoCep(formatCep(e.target.value))}
              placeholder="99999-999"
              inputMode="numeric"
              className="mt-1"
              maxLength={9}
            />
          </div>

          {totalBairros > 0 && (
            <div className="bg-orange-500/10 border border-orange-500/20 rounded-lg p-3">
              <p className="text-sm text-orange-700 dark:text-orange-300">
                <AlertCircle className="w-4 h-4 inline mr-1" />O CEP será aplicado aos{" "}
                <strong>{totalBairros}</strong> bairro(s) já cadastrado(s).
              </p>
            </div>
          )}

          <div className="flex gap-2 pt-4">
            <Button variant="outline" className="flex-1" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <Button className="flex-1" onClick={onConfirmar} disabled={saving || !novoCep.trim()}>
              {saving ? "Ativando..." : "Ativar CEP Único"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
